import { render } from "./AdminMessages.vue?vue&type=template&id=59d8c182&scoped=true"
import script from "./AdminMessages.vue?vue&type=script&lang=js"
export * from "./AdminMessages.vue?vue&type=script&lang=js"

import "./AdminMessages.vue?vue&type=style&index=0&id=59d8c182&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d8c182"]])

export default __exports__